import { endpoints } from '@/config';
import get from './get';

/**
 * @param {string} scope - expression
 * @param {string} view - 'log' for raw telemetry dump
 */
export default async function getTelemetryHistory(accountId, {
  scope,
  deviceId,
  deviceIds,
  property,
  properties,
  pivotProperty,
  period,
  offset,
  view,
  range,
} = {}) {
  const resource = '/history';
  const overrides = {
    method: 'GET',
    url: `${endpoints.telemetry}${resource}`,
  };
  return get(overrides, {
    accountId,
    scope,
    deviceId,
    deviceIds,
    property,
    properties,
    pivotProperty,
    period,
    offset,
    view,
    range,
  }, { resource });
}
